function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import useLazyRef from '@mui/utils/useLazyRef';
import { useGridApiEventHandler, gridRowsLoadingSelector, useGridApiMethod, useGridSelector } from '@mui/x-data-grid';
import { gridRowGroupsToFetchSelector } from '@mui/x-data-grid/internals';
import { unstable_debounce as debounce } from '@mui/utils';
import { gridGetRowsParamsSelector, gridDataSourceErrorsSelector } from "./gridDataSourceSelector.js";
import { NestedDataManager, RequestStatus, runIfServerMode } from "./utils.js";
import { GridDataSourceCacheDefault } from "./cache.js";
var INITIAL_STATE = {
    loading: {},
    errors: {}
};
var noopCache = {
    clear: function() {},
    get: function() {
        return undefined;
    },
    set: function() {}
};
function getCache(cacheProp) {
    if (cacheProp === null) {
        return noopCache;
    }
    return cacheProp !== null && cacheProp !== void 0 ? cacheProp : new GridDataSourceCacheDefault({});
}
export var dataSourceStateInitializer = function(state) {
    return _extends({}, state, {
        dataSource: INITIAL_STATE
    });
};
export var useGridDataSource = function(apiRef, props) {
    var _props_unstable_dataSource, _props_unstable_dataSource1;
    var nestedDataManager = useLazyRef(function() {
        return new NestedDataManager(apiRef);
    }).current;
    var groupsToAutoFetch = useGridSelector(apiRef, gridRowGroupsToFetchSelector);
    var scheduledGroups = React.useRef(0);
    var onError = props.unstable_onDataSourceError;
    var _React_useState = _sliced_to_array(React.useState(function() {
        return getCache(props.unstable_dataSourceCache);
    }), 2), cache = _React_useState[0], setCache = _React_useState[1];
    var fetchRows = React.useCallback(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(parentId) {
            var _props_unstable_dataSource, getRows, dataSourceState, fetchParams, cachedData, rows, isLoading, getRowsResponse, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        getRows = (_props_unstable_dataSource = props.unstable_dataSource) === null || _props_unstable_dataSource === void 0 ? void 0 : _props_unstable_dataSource.getRows;
                        if (!getRows) {
                            return [
                                2
                            ];
                        }
                        if (parentId) {
                            nestedDataManager.queue([
                                parentId
                            ]);
                            return [
                                2
                            ];
                        }
                        nestedDataManager.clear();
                        scheduledGroups.current = 0;
                        dataSourceState = apiRef.current.state.dataSource;
                        if (dataSourceState !== INITIAL_STATE) {
                            apiRef.current.resetDataSourceState();
                        }
                        fetchParams = _extends({}, gridGetRowsParamsSelector(apiRef), apiRef.current.unstable_applyPipeProcessors('getRowsParams', {}));
                        cachedData = apiRef.current.unstable_dataSource.cache.get(fetchParams);
                        if (cachedData !== undefined) {
                            rows = cachedData.rows;
                            apiRef.current.setRows(rows);
                            if (cachedData.rowCount !== undefined) {
                                apiRef.current.setRowCount(cachedData.rowCount);
                            }
                            return [
                                2
                            ];
                        }
                        isLoading = gridRowsLoadingSelector(apiRef);
                        if (!isLoading) {
                            apiRef.current.setLoading(true);
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            getRows(fetchParams)
                        ];
                    case 2:
                        getRowsResponse = _state.sent();
                        apiRef.current.unstable_dataSource.cache.set(fetchParams, getRowsResponse);
                        if (getRowsResponse.rowCount !== undefined) {
                            apiRef.current.setRowCount(getRowsResponse.rowCount);
                        }
                        apiRef.current.setRows(getRowsResponse.rows);
                        apiRef.current.setLoading(false);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        apiRef.current.setRows([]);
                        apiRef.current.setLoading(false);
                        onError === null || onError === void 0 ? void 0 : onError(error, fetchParams);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(parentId) {
            return _ref.apply(this, arguments);
        };
    }(), [
        nestedDataManager,
        apiRef,
        (_props_unstable_dataSource = props.unstable_dataSource) === null || _props_unstable_dataSource === void 0 ? void 0 : _props_unstable_dataSource.getRows,
        onError
    ]);
    var fetchRowChildren = React.useCallback(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(id) {
            var _pipedParams_groupFields, _props_unstable_dataSource, pipedParams, _pipedParams_groupFields_length, getRows, rowNode, fetchParams, cachedData, rows, _gridDataSourceErrorsSelector_id, existingError, getRowsResponse, error, childrenFetchError;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        pipedParams = apiRef.current.unstable_applyPipeProcessors('getRowsParams', {});
                        if (!props.treeData && ((_pipedParams_groupFields_length = (_pipedParams_groupFields = pipedParams.groupFields) === null || _pipedParams_groupFields === void 0 ? void 0 : _pipedParams_groupFields.length) !== null && _pipedParams_groupFields_length !== void 0 ? _pipedParams_groupFields_length : 0) === 0) {
                            nestedDataManager.clearPendingRequest(id);
                            return [
                                2
                            ];
                        }
                        getRows = (_props_unstable_dataSource = props.unstable_dataSource) === null || _props_unstable_dataSource === void 0 ? void 0 : _props_unstable_dataSource.getRows;
                        if (!getRows) {
                            nestedDataManager.clearPendingRequest(id);
                            return [
                                2
                            ];
                        }
                        rowNode = apiRef.current.getRowNode(id);
                        if (!rowNode) {
                            nestedDataManager.clearPendingRequest(id);
                            return [
                                2
                            ];
                        }
                        fetchParams = _extends({}, gridGetRowsParamsSelector(apiRef), pipedParams, {
                            groupKeys: rowNode.path
                        });
                        cachedData = apiRef.current.unstable_dataSource.cache.get(fetchParams);
                        if (cachedData !== undefined) {
                            rows = cachedData.rows;
                            nestedDataManager.setRequestSettled(id);
                            apiRef.current.updateServerRows(rows, rowNode.path);
                            if (cachedData.rowCount) {
                                apiRef.current.setRowCount(cachedData.rowCount);
                            }
                            apiRef.current.setRowChildrenExpansion(id, true);
                            apiRef.current.unstable_dataSource.setChildrenLoading(id, false);
                            return [
                                2
                            ];
                        }
                        existingError = (_gridDataSourceErrorsSelector_id = gridDataSourceErrorsSelector(apiRef)[id]) !== null && _gridDataSourceErrorsSelector_id !== void 0 ? _gridDataSourceErrorsSelector_id : null;
                        if (existingError) {
                            apiRef.current.unstable_dataSource.setChildrenFetchError(id, null);
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        return [
                            4,
                            getRows(fetchParams)
                        ];
                    case 2:
                        getRowsResponse = _state.sent();
                        if (!apiRef.current.getRowNode(id)) {
                            // The row has been removed from the grid
                            nestedDataManager.clearPendingRequest(id);
                            return [
                                2
                            ];
                        }
                        if (nestedDataManager.getRequestStatus(id) === RequestStatus.UNKNOWN) {
                            apiRef.current.unstable_dataSource.setChildrenLoading(id, false);
                            return [
                                2
                            ];
                        }
                        nestedDataManager.setRequestSettled(id);
                        apiRef.current.unstable_dataSource.cache.set(fetchParams, getRowsResponse);
                        if (getRowsResponse.rowCount) {
                            apiRef.current.setRowCount(getRowsResponse.rowCount);
                        }
                        apiRef.current.updateServerRows(getRowsResponse.rows, rowNode.path);
                        apiRef.current.setRowChildrenExpansion(id, true);
                        return [
                            3,
                            5
                        ];
                    case 3:
                        error = _state.sent();
                        childrenFetchError = error;
                        apiRef.current.unstable_dataSource.setChildrenFetchError(id, childrenFetchError);
                        onError === null || onError === void 0 ? void 0 : onError(childrenFetchError, fetchParams);
                        return [
                            3,
                            5
                        ];
                    case 4:
                        apiRef.current.unstable_dataSource.setChildrenLoading(id, false);
                        nestedDataManager.setRequestSettled(id);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(), [
        nestedDataManager,
        onError,
        apiRef,
        props.treeData,
        (_props_unstable_dataSource1 = props.unstable_dataSource) === null || _props_unstable_dataSource1 === void 0 ? void 0 : _props_unstable_dataSource1.getRows
    ]);
    var setChildrenLoading = React.useCallback(function(parentId, isLoading) {
        apiRef.current.setState(function(state) {
            if (!state.dataSource.loading[parentId] && isLoading === false) {
                return state;
            }
            var newLoadingState = _extends({}, state.dataSource.loading);
            if (isLoading === false) {
                delete newLoadingState[parentId];
            } else {
                newLoadingState[parentId] = isLoading;
            }
            return _extends({}, state, {
                dataSource: _extends({}, state.dataSource, {
                    loading: newLoadingState
                })
            });
        });
    }, [
        apiRef
    ]);
    var setChildrenFetchError = React.useCallback(function(parentId, error) {
        apiRef.current.setState(function(state) {
            var newErrorsState = _extends({}, state.dataSource.errors);
            if (error === null && newErrorsState[parentId] !== undefined) {
                delete newErrorsState[parentId];
            } else {
                newErrorsState[parentId] = error;
            }
            return _extends({}, state, {
                dataSource: _extends({}, state.dataSource, {
                    errors: newErrorsState
                })
            });
        });
    }, [
        apiRef
    ]);
    var resetDataSourceState = React.useCallback(function() {
        apiRef.current.setState(function(state) {
            return _extends({}, state, {
                dataSource: INITIAL_STATE
            });
        });
    }, [
        apiRef
    ]);
    var debouncedFetchRows = React.useMemo(function() {
        return debounce(fetchRows, 0);
    }, [
        fetchRows
    ]);
    var dataSourceApi = {
        unstable_dataSource: {
            setChildrenLoading: setChildrenLoading,
            setChildrenFetchError: setChildrenFetchError,
            fetchRows: fetchRows,
            cache: cache
        }
    };
    var dataSourcePrivateApi = {
        fetchRowChildren: fetchRowChildren,
        resetDataSourceState: resetDataSourceState
    };
    useGridApiMethod(apiRef, dataSourceApi, 'public');
    useGridApiMethod(apiRef, dataSourcePrivateApi, 'private');
    useGridApiEventHandler(apiRef, 'sortModelChange', runIfServerMode(props.sortingMode, debouncedFetchRows));
    useGridApiEventHandler(apiRef, 'filterModelChange', runIfServerMode(props.filterMode, debouncedFetchRows));
    useGridApiEventHandler(apiRef, 'paginationModelChange', runIfServerMode(props.paginationMode, debouncedFetchRows));
    var isFirstRender = React.useRef(true);
    React.useEffect(function() {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        var newCache = getCache(props.unstable_dataSourceCache);
        setCache(function(prevCache) {
            return prevCache !== newCache ? newCache : prevCache;
        });
    }, [
        props.unstable_dataSourceCache
    ]);
    React.useEffect(function() {
        if (props.unstable_dataSource) {
            apiRef.current.unstable_dataSource.cache.clear();
            apiRef.current.unstable_dataSource.fetchRows();
        }
    }, [
        apiRef,
        props.unstable_dataSource
    ]);
    React.useEffect(function() {
        if (groupsToAutoFetch && groupsToAutoFetch.length && scheduledGroups.current < groupsToAutoFetch.length) {
            var groupsToSchedule = groupsToAutoFetch.slice(scheduledGroups.current);
            nestedDataManager.queue(groupsToSchedule);
            scheduledGroups.current = groupsToAutoFetch.length;
        }
    }, [
        apiRef,
        nestedDataManager,
        groupsToAutoFetch
    ]);
};
